function CLSfilterImprove(){
if(window.location.pathname.split('/')[2]=="shop-fitness" && window.location.pathname.split('/')[2] !== undefined){
document.querySelector('.wb-shop-grid--shop-fitness').style.display='none';
}else{
document.querySelector('.wb-shop-grid--shop-fitness').style.display='block';
}
}
//CLSfilterImprove();

window.wbShopFilter.enableDisplayActiveFilters();

$(document).ready(function() {
  
  var $p_filter = $('.wb-shop-filter-desktop');
  var $p_filter_checkboxes_blackfriday = $p_filter.find('.wb-shop-filter__checkbox-blackfriday');
  var $p_filter_checkboxes_range = $p_filter.find('.wb-shop-filter__checkbox-range');
  var $p_filter_checkboxes_category = $p_filter.find('.wb-shop-filter__checkbox-category');
  var $p_filter_checkboxes_collection = $p_filter.find('.wb-shop-filter__checkbox-collection');
  var $p_filter_checkboxes_key = $p_filter.find('.wb-shop-filter__checkbox-key');
  var $p_filter_checkboxes_athletes = $p_filter.find('.wb-shop-filter__checkbox-athletes');
  var $p_filter_checkboxes_type = $p_filter.find('.wb-shop-filter__checkbox-type');
  var $p_filter_checkboxes_other = $p_filter.find('.wb-shop-filter__checkbox-other');
  var $p_filter_list = document.querySelector('.wb-shop-filter-desktop__list');
  var categoryFilterList = ['shaping-supplements', 'beauty-supplements', 'superfoods', 'health-supplements', 'functional-foods', 'female-health', 'energy-drinks', 'accessories'];


  
  $p_filter_checkboxes_blackfriday.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, $p_filter_checkboxes_blackfriday, ['basics',/*'20off','20-30off', '30off', 'bogo', '30-40off',*/'10-40off', '50off', '60off', '75off', '50-60off', '60-70off', '70-80off']));
  });
  $p_filter_checkboxes_range.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, $p_filter_checkboxes_range, categoryFilterList));
  });
  $p_filter_checkboxes_category.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });
  $p_filter_checkboxes_collection.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });
  $p_filter_checkboxes_key.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });
  $p_filter_checkboxes_athletes.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });
  $p_filter_checkboxes_type.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });
  $p_filter_checkboxes_other.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });
  
  // filter fixed on header desktop
  /*if ($(window).width()>995){
    $(window).scroll(function(){
      var filterScrollTop = 200;
      var filterScroll = $(window).scrollTop()-filterScrollTop;
      var shopProductsHeight = $('.wb-shop-products').height();
      var filterSrollRef = $(window).scrollTop()+500;

      var currentFilterPosition = $(window).scrollTop()+$('.wb-shop-filter-fixed').height()-350;
      var currentShopHeight = $('.wb-shop-product_grid').height();

      if($(window).scrollTop() >= filterScrollTop && filterSrollRef < shopProductsHeight){

        $('.wb-shop-filter-fixed').css('position','fixed');
        $('.wb-shop-filter-fixed').css('top','70px');

      }
      if($(window).scrollTop() < filterScrollTop){
        $('.wb-shop-filter-fixed').css('position','relative');
        $('.wb-shop-filter-fixed').css('top','0px');
      } 

      if(currentShopHeight > $('.wb-shop-filter-fixed').height() && currentShopHeight < currentFilterPosition){
        $('.wb-shop-filter-fixed').css('position','relative');
        $('.wb-shop-filter-fixed').css('margin-top',currentShopHeight-$('.wb-shop-filter-fixed').height());
      }else {
        $('.wb-shop-filter-fixed').css('margin-top','0px');

      }

    });


  }*/

  function initcountItems(){
    var filteredItems = $('.wb-product-item-2019').length;
    $('.filter-result-count-desk').text(filteredItems); 
    //wbShopFilter.countCategories(categoryFilterList);
  }

  function initcountFilter() {
    var filter = wbShopFilter.getFilter();
    if(filter && filter.length > 0) {
      $('.filter-options-count').text(filter.length);
    }
  }

  window.wbShopFilter.initCategoryFilter(categoryFilterList);
  initcountItems();
  initcountFilter();
 // window.wbShopFilter.initUrlFilter(categoryFilterList);
  window.wbShopFilter.initMainFilterClass();
});
